import ITabMenuContentSection from "./ITabMenuContentSection";

export enum Menus {
  docs = "docs",
  support = "support",
}

export default interface ITabInfo {
  label: string;
  route: string;
  includedRoles?: string[];
  menu?: Menus;
  menuContent?: Array<ITabMenuContentSection>;
}
